import Backbone from 'backbone';
import Handlebars from 'handlebars';
import {
  templateUrls
} from './../../../base/vars.js';
import { EventHandler } from './../../../base/utils.js';

export default Backbone.View.extend({
  el: '.app',

  initialize() {
    $('.app').html(this.el);
    this.getTemplate();
  },

  getTemplate() {
    $.ajax({
      url: templateUrls.spinner,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },
  // Timeout set to Duration on Page loader animation (5.85s)
  startTimeout() {
    setTimeout(() => {
      this.goToConfirmation();
    }, 5850);
  },

  goToConfirmation() {
    this.undelegateEvents();
    Backbone.history.loadUrl('confirmation');
  },

  render() {
    this.$el.find('.app-step-container').empty();
    this.$el.html(this.template(this.model.toJSON()));
    this.startTimeout();
  }
});
